// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  deleteWrapper,
  fetchWrapper,
  postFormDataWrapper,
  postWrapper,
  putWrapper,
} from 'helpers/api'

export const checkModulationStatus = modId => fetchWrapper(`/radio-modulations/check-status/${modId}`)

export const copyRadioById = (radioId, body) => postWrapper(`/radios/copy/${radioId}`, body)

export const deleteRadioById = id => deleteWrapper(`/radios/${id}`)

export const deleteRadioCommentById = (radioId, radioCommentId) => (
  deleteWrapper(`/radios/${radioId}/comments/${radioCommentId}`)
)

export const deleteRadioCommentFile = radioCommentFileId => deleteWrapper(`/radio-comment-files/${radioCommentFileId}`)

export const deleteRadioCSVMapping = id => deleteWrapper(`/radio-csv-mappings/${id}`)

export const fetchNewRadioCodes = (query = '') => fetchWrapper(`/radios/new-radio-codes${query}`)

export const fetchRadioArchitectures = () => fetchWrapper('/radio-architectures')

export const fetchRadioAtpcTypes = () => fetchWrapper('/atpc-types')

export const fetchRadioById = d => fetchWrapper(`/radios/${d}`)

// this value can have characters which should be escaped.
export const fetchRadioByRadioCode = c => (
  fetchWrapper(`/radios/radio-code/${encodeURIComponent(c)}`)
)

export const fetchRadioCompanies = (c = '') => fetchWrapper(`/radios/companies${c}`)

export const fetchRadioCSVMappings = (q = '') => fetchWrapper(`/radio-csv-mappings${q}`)

export const fetchRadioCurveSetByFilterReferenceCode = f => (
  fetchWrapper(`/radio-curve-sets/filter-reference-code/${f}`)
)

export const fetchRadioCurveTypeCodes = () => fetchWrapper('/curve-type-codes')

export const fetchRadioDuplexModes = () => fetchWrapper('/duplex-modes')

// this is not used anywhere save for below.
// so no need to export currently.
// this is separated for modularity and readability
const fetchRadioFamilies = (f = '') => fetchWrapper(`/radio-families${f}`)

// builds a query to support any values which should be escaped.
// this specific query is used in a few different scenarios across the application
export const fetchRadioFamiliesContaining = (value = '') => {
  const query = [{
    field: 'radioFamilyContains',
    value,
  }]
  return fetchRadioFamilies(assembleQuery(query))
}

export const fetchRadioFavoritesByRadioId = r => fetchWrapper(`/radios/${r}/favorites`)

export const fetchRadioModulationModelNumbers = (m = '') => fetchWrapper(`/radios/modulations/model-numbers${m}`)

export const fetchRadioModulationSchemes = () => fetchWrapper('/modulation-schemes')

export const fetchRadioModulationTypes = () => fetchWrapper('/radio-modulation-types')

export const fetchRadioPowerTypes = () => fetchWrapper('/power-types')

export const fetchRadioRadioTypes = () => fetchWrapper('/radio-types')

export const fetchRadiosByQuery = q => fetchWrapper(`/radios${q}`)

export const fetchRadioStabilities = () => fetchWrapper('/stabilities')

export const fetchRadioStatuses = () => fetchWrapper('/statuses')

export const postNewRadio = v => postWrapper('/radios', v)

export const postNewRadioFamily = f => postWrapper('/radio-families', f)

export const postNewRadioFavorite = f => postWrapper('/radios/create-favorite', f)

export const postRadioComment = (entityId, comment) => (
  postFormDataWrapper(`/radios/${entityId}/comments`, comment)
)

export const postRadioCSVMapping = mapping => (
  postWrapper('/radio-csv-mappings', mapping)
)

export const updateRadio = v => putWrapper('/radios', v)
